<template>
    <div class="ppv2-flex ppv2-flex-wrap ppv2-mb-8 ppv2-w-full" :style="{ gap: normalizeSize(16, true) }">
        <StatsCard
            v-for="item in navItems"
            :key="item.key"
            class="ppv2-flex-1 ppv2-min-w-[200px]"
            :isActive="activeTab === item.key"
            :count="stats[item.countKey] || 0"
            :label="item.label"
            :icon="item.icon"
            @click="$emit('click', item.key)"
            :token="token"
        />
    </div>
</template>

<script>
import normalizeSize from '../../../utils/normalizeSize'

import StatsCard from '../Food/StatsCard.vue'
import { Users, Network, Infinity, Ticket, Gift } from 'lucide-vue'

export default {
    name: 'CustomerStatsNavigation',
    components: {
        StatsCard,
    },
    props: {
        activeTab: {
            type: String,
            required: true,
        },
        stats: {
            type: Object,
            required: true,
            default: () => ({
                customers: 0,
                groups: 0,
                billetsNonDatees: 0,
                subscriptions: 0,
                vouchers: 0,
                treatments: 0,
                subscriptions_treatments: 0,
            }),
        },
        token: {
            type: String,
            required: true,
        },
        permissions: {
            type: Object,
            default: () => ({
                customers: true,
                groups: true,
                subscriptions: true,
                vouchers: true,
                billetsNonDatees: true,
            }),
        },
    },
    data() {
        return {}
    },
    computed: {
        navItems() {
            return [
                {
                    key: 'customers',
                    countKey: 'customers',
                    label: this.$t('customers.navigation.customers'),
                    icon: Users,
                    show: this.permissions.customers,
                },
                {
                    key: 'groups',
                    countKey: 'groups',
                    label: this.$t('customers.navigation.groups'),
                    icon: Network,
                    show: this.permissions.groups,
                },
                {
                    key: 'subscriptions',
                    countKey: 'subscriptions_treatments',
                    label: this.$t('customers.navigation.subscriptions'),
                    icon: Infinity,
                    show: this.permissions.subscriptions,
                },
                {
                    key: 'vouchers',
                    countKey: 'vouchers',
                    label: this.$t('customers.navigation.vouchers'),
                    icon: Gift,
                    show: this.permissions.vouchers,
                },
                {
                    key: 'billetsNonDatees',
                    countKey: 'billetsNonDatees',
                    label: this.$t('customers.navigation.billetsNonDatees'),
                    icon: Ticket,
                    show: this.permissions.billetsNonDatees,
                },
            ].filter((item) => item.show)
        },
    },
    methods: {
        normalizeSize,
    },
}
</script>
